import axios from 'axios';

// Use gateway URL instead of direct payment service URL
// Gateway runs on port 5000/5001, payment service runs on 9000
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

// Create axios instance with auth token
const getAxiosInstance = () => {
  const token = localStorage.getItem('token');
  return axios.create({
    baseURL: API_BASE_URL,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    withCredentials: true,
  });
};

export const subscriptionService = {
  /**
   * Get subscription status.
   * @param {Object} [options]
   * @param {boolean} [options.cacheBust] - When true, appends timestamp query to avoid cached/304 responses (use for polling).
   */
  async getSubscription(options = {}) {
    try {
      const params = options.cacheBust ? { _: Date.now() } : undefined;
      const response = await getAxiosInstance().get('/payments/subscription', { params });
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.message || 'Failed to get subscription status'
      );
    }
  },

  // // Create Razorpay order (legacy one-time)
  // async createOrder(planType, billingCycle) {
  //   try {
  //     const response = await getAxiosInstance().post('/payments/subscription/create-order', {
  //       planType,
  //       billingCycle,
  //     });
  //     return response.data;
  //   } catch (error) {
  //     throw new Error(
  //       error.response?.data?.message || 'Failed to create order'
  //     );
  //   }
  // },

  /** Create Razorpay subscription (recurring); returns subscriptionId + keyId for checkout. Sends billing (name, email, mobile) for backend validation. */
  async createSubscription(planType, billingCycle, billing = {}) {
    try {
      const response = await getAxiosInstance().post('/payments/subscription/create', {
        planType,
        billingCycle,
        name: billing?.name?.trim?.(),
        email: billing?.email?.trim?.(),
        mobile: billing?.mobile?.trim?.(),
      });
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.message || 'Failed to create subscription'
      );
    }
  },

  // // Verify payment (legacy order-based)
  // async verifyPayment(paymentData) {
  //   try {
  //     const response = await getAxiosInstance().post('/payments/subscription/verify-payment', paymentData);
  //     return response.data;
  //   } catch (error) {
  //     throw new Error(
  //       error.response?.data?.message || 'Failed to verify payment'
  //     );
  //   }
  // },

  /** Cancel subscription at end of billing cycle */
  async cancelSubscription() {
    try {
      const response = await getAxiosInstance().post('/payments/subscription/cancel');
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.message || 'Failed to cancel subscription'
      );
    }
  },

  // Track profile view
  async trackProfileView(influencerUsername) {
    try {
      const response = await getAxiosInstance().post('/company/profile-views/track', {
        influencerUsername,
      });
      return response.data;
    } catch (error) {
      // For gating flows we need the payload even on 403, so return it when present.
      if (error.response?.data) {
        return error.response.data;
      }
      throw new Error(error.message || 'Failed to track profile view');
    }
  },
};
